import { StreamActions } from '@hotwired/turbo'

StreamActions.close_modal = function () {
  const element = document.getElementById('modal_container')
  element?.controllers?.modal?.close()
}
